import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { setLanguage } from "../redux/slices/profileSlice";
import { useEffect } from "react";
import i18n from "../i18n";

const languageOptions = [
    {
        label: "English",
        value: "en",
    },
    {
        label: "Lithuanian",
        value: "lt",
    },
    {
        label: "Español",
        value: "es",
    },
];

export default function LanguageDropdown() {
    const language = useSelector((state) => state.profileData.language);
    const dispatch = useDispatch();

    const handleLanguageChange = (selectedOption) => {
        dispatch(setLanguage(selectedOption?.value));
    };

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);

    return (
        <Select
            value={languageOptions?.find((option) => option.value === language)}
            onChange={handleLanguageChange}
            options={languageOptions}
            className="!text-black "
            menuPlacement="top"
            classNamePrefix="select"
            styles={{
                control: (provided, state) => ({
                    ...provided,
                    cursor: "pointer",
                    border: state.isFocused
                        ? "1px solid #6a7185"
                        : "1px solid #e5e7eb",
                    borderRadius: 8,
                    backgroundColor: "white",
                    boxShadow: null,
                    paddingLeft: "9px",
                    "&:hover": {
                        borderColor: "#6a7185",
                    },
                }),
                clearIndicator: (provided, props) => ({
                    ...provided,
                    color: "pink",
                    "&:hover": {
                        color: "red",
                    },
                }),
                option: (provided) => ({
                    ...provided,
                    cursor: "pointer",
                    zIndex: 99,
                }),
            }}
        />
    )
}
